/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, June 19, 2014
 * For information or permission request, email info@aetonixsystems.com
 */

"use strict";

var Model = require("../types/Model.js");

module.exports = Model({
	name: "managedcareplanexpander",
	init: init,
	triggers: triggers,
});

function init() {
	this.push("");
}

function triggers() {
	return {
		expand: expand,
		contract: contract
	};
}

function expand(data) {
	var section = data.section || "";
	this.push(section);
}

function contract() {
	this.push("");
}
